/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('./normalize-component-d885d5ff.js');

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var __nuxt = process && !!process.env.isNuxt;
var script = {
  name: "MqLink",
  data: function data() {
    return {
      nuxtPlatform: __nuxt
    };
  },
  props: {
    vue: {
      type: String,
      default: "a"
    },
    nuxt: {
      type: String,
      default: "a"
    },
    locale: {
      type: String,
      default: "en"
    },
    link: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    }
  },
  methods: {
    vuemEvent: function vuemEvent(link) {
      this.$router.push(link);
      this.$emit('linkCallBack');
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "label",
    [
      _vm.vue == "a" && _vm.nuxt == "a"
        ? _c(
            "a",
            {
              class: _vm.className,
              attrs: { p: "a", href: "/" + _vm.locale + _vm.link },
            },
            [_vm._t("default")],
            2
          )
        : !!_vm.nuxtPlatform
        ? [
            _vm.nuxt == "nuxt-link"
              ? _c(
                  "nuxt-link",
                  {
                    class: _vm.className,
                    attrs: { p: "nuxt", to: "/" + _vm.locale + _vm.link },
                  },
                  [_vm._t("default")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.nuxt == "a"
              ? _c(
                  "a",
                  {
                    class: _vm.className,
                    attrs: { p: "nuxt-a", href: "/" + _vm.locale + _vm.link },
                  },
                  [_vm._t("default")],
                  2
                )
              : _vm._e(),
          ]
        : [
            _vm.vue == "router-link"
              ? _c(
                  "router-link",
                  { class: _vm.className, attrs: { p: "vue", to: _vm.link } },
                  [_vm._t("default")],
                  2
                )
              : _vm.vue == "m"
              ? _c(
                  "div",
                  {
                    class: _vm.className,
                    attrs: { p: "vue-m" },
                    on: {
                      click: function ($event) {
                        return _vm.vuemEvent(_vm.link)
                      },
                    },
                  },
                  [_vm._t("default")],
                  2
                )
              : _c(
                  "a",
                  {
                    class: _vm.className,
                    attrs: { p: "vue-a", href: "/" + _vm.locale + _vm.link },
                  },
                  [_vm._t("default")],
                  2
                ),
          ],
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

exports.__vue_component__ = __vue_component__;
